import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useGetReviews } from "hooks/queries/useGetReviews";
import EvaluationCard from "./EvaluationCard";
import { useNavigate } from "react-router-dom";

const UserReview = () => {
  const { reviews } = useGetReviews();
  console.log("Reviews", reviews);
  const navigate = useNavigate();

  const handleEvaluate = (id: string) => {
    navigate(`/evaluation/${id}`);
  };

  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="h4" fontSize="28px" fontWeight={800}>
        Evaluation
      </Typography>
      <Grid container spacing={2}>
        {reviews?.map((review, index) => {
          return index > 0 && (
            <Grid item xs={12} md={3} key={index}>
              <EvaluationCard review={review} onEvaluate={handleEvaluate} />
            </Grid>
          )
        })}
      </Grid>
    </Box>
  );
};

export default UserReview;
